import { useEffect, useMemo } from 'react'
import {
  Link,
  generatePath,
  useLoaderData,
  useLocation
} from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { Pill } from '@/shared/components/pill'
import { AttachmentTableWithTabs } from '@/shared/components/attachments'
import { store } from '@/store'
import { employeeContractAttachmentApi } from '@/store/services'
import { useAuthorization } from '@/hooks'
import { HasAccess } from '@permify/react-role'

export const EmployeeAttachments = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const [currentEmployee] = useLoaderData()
  const defaultSearchParams = {
    employee_id: currentEmployee.id
  }

  const currentUrlParams = useLocation().search

  const pillOptions = useMemo(() => {
    return [
      { label: 'Nombre', value: currentEmployee.fullName },
      { label: 'RUT', value: currentEmployee.documentNumber }
    ]
  }, [currentEmployee])

  const getMore = async (searchParams) => {
    try {
      const { employee_contract_attachments: attachments = [], meta = {} } =
        await store
          .dispatch(
            employeeContractAttachmentApi.endpoints.getEmployeeContractAttachments.initiate(
              `?${searchParams.toString()}`
            )
          )
          .unwrap()

      const currentPage = Number(searchParams.get('page'))
      const hasMore = currentPage < meta?.pagination?.total_pages

      return {
        attachments,
        hasMore
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    hasAccess('employee#attachments')
  }, [])

  return (
    <Dialog size='xl' className='h-4/5' open={true}>
      <DialogHeader>Detalle de documentos subidos</DialogHeader>

      <DialogBody className='overflow-hidden' style={{ height: 'inherit' }}>
        <div className='flex gap-3 mb-5'>
          {!!pillOptions.length &&
            pillOptions.map(({ value, label }) => (
              <Pill key={value} label={label} value={value} />
            ))}
        </div>

        <AttachmentTableWithTabs
          initialSearchParams={defaultSearchParams}
          getMore={getMore}
        />
      </DialogBody>

      <DialogFooter className='flex gap-3'>
        <Link to={generatePath(`/employees${currentUrlParams}`)}>
          <Button variant='outlined' color='white'>
            Volver
          </Button>
        </Link>

        <Link
          to={
            generatePath('/employees/:id/upload_attachments', {
              id: currentEmployee.id
            }) + `?${currentUrlParams}`
          }
        >
          <Button>Añadir documento</Button>
        </Link>
      </DialogFooter>
    </Dialog>
  )
}
